import React, { useState, useEffect } from 'react';
import { Tag } from 'lucide-react';
import { useSale, countdownSale } from '../utils/sale';

function timeLeft(endsAt) {
  const diff = new Date(endsAt) - new Date();
  if (diff <= 0) return null;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  if (d > 0) return `${d}d ${h}h left`;
  if (h > 0) return `${h}h ${m}m left`;
  return `${m}m left`;
}

const SaleBanner = () => {
  const saleData = useSale();
  const [, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 60000);
    return () => clearInterval(id);
  }, []);

  const sale = countdownSale(saleData);
  if (!sale) return null;
  const remaining = timeLeft(sale.endsAt);

  return (
    <div
      data-testid="sale-banner"
      className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-cyan-600 via-blue-600 to-cyan-600 text-white text-center text-sm sm:text-base font-semibold h-9 px-4 flex items-center justify-center gap-2"
    >
      <Tag size={16} className="shrink-0" />
      <span>
        Limited Time: <span className="font-bold">{sale.percent}% OFF</span>{' '}
        {Array.isArray(sale.categories) && sale.categories.length > 0 ? 'Cold Plunges' : 'everything'}
      </span>
      {remaining && (
        <span className="hidden sm:inline-flex items-center bg-white/20 rounded-full px-2.5 py-0.5 text-xs font-bold">
          {remaining}
        </span>
      )}
    </div>
  );
};

export default SaleBanner;
